var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6fa59;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.98,52.9c-39.07,0-70.86,31.8-70.86,70.89,0,15.82,6.95,28.42,13.66,40.61,.67,1.22,1.34,2.43,2,3.65,11.33,20.85,48.27,74.01,49.83,76.26l10.85-.2c.36-.56,36.31-56.46,49.53-75.7,10.83-15.75,15.87-29.93,15.87-44.61,0-39.09-31.8-70.89-70.89-70.89Zm44.27,108.11c-10.24,14.9-33.86,51.39-44.45,67.81-10.97-15.97-35.11-51.5-43.54-67.01-.67-1.24-1.35-2.47-2.04-3.71-6.19-11.23-12.04-21.84-12.04-34.31,0-31.89,25.93-57.84,57.81-57.84s57.84,25.95,57.84,57.84c0,11.92-4.31,23.75-13.57,37.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150,89.35c-18.52,0-33.59,15.07-33.59,33.59s15.07,33.59,33.59,33.59,33.59-15.07,33.59-33.59-15.07-33.59-33.59-33.59Zm0,54.12c-11.32,0-20.54-9.21-20.54-20.54s9.21-20.54,20.54-20.54,20.54,9.21,20.54,20.54-9.21,20.54-20.54,20.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.16437028a4cd14cde708e5b6d5fdf4f2.svg";
export { ForwardRef as ReactComponent };